import React from "react";
import { Star } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Ankita did such a good job with our brand and is such a gem to work with. I would work with her again.",
    name: "Shauna Kay Watson",
    role: "CEO & Founder, Unpopular You",
    photo: "/testimonials/shauna.jpg",
    type: "person",
  },
  {
    quote:
      "I highly recommend Ankita to anyone looking for a creative professional who combines strategic thinking with outstanding design execution.",
    name: "Ansh Malhotra",
    role: "Co-Founder, Nexist",
    photo: "/testimonials/ansh.jpg",
    type: "person",
  },
  {
    quote:
      "She consistently delivers thoughtful, high-quality creative work and has played an important role in strengthening our brand presence. Her ability to understand business objectives, transform ideas into compelling visuals, and maintain consistency across every touchpoint is exceptional.",
    name: "Neha Malhotra",
    role: "CFO & Co-Founder, Nexist",
    photo: "/testimonials/neha.jpg",
    type: "person",
  },
  {
    quote:
      "She understood our vision quickly and transformed it into a beautiful, modern, and user-friendly landing page. Her attention to detail, creative thinking, and ability to balance aesthetics with functionality made the entire process seamless.",
    name: "Suttons Bakery",
    role: "Heritage Bakery · Echuca",
    photo: "/testimonials/suttons.webp",
    type: "logo",
  },
];

export const Testimonials = () => {
  return (
    <section className="py-24 md:py-32 lg:py-40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <Reveal>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="text-xs tracking-[0.25em] uppercase font-semibold text-gold">Testimonials</span>
            </div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-charcoal">
              Words from <span className="italic text-burgundy">the founders.</span>
            </h2>
          </Reveal>
        </div>

        <StaggerGroup
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 items-stretch"
          stagger={0.08}
        >
          {TESTIMONIALS.map((t) => (
            <StaggerItem key={t.name} className="h-full">
              <div
                className="h-full flex flex-col items-center text-center backdrop-blur-md bg-white/50 border border-charcoal/5 rounded-3xl p-8 hover:-translate-y-1 hover:shadow-[0_30px_60px_-40px_rgba(34,34,34,0.4)] transition-all duration-500"
                data-testid={`testimonial-${t.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {/* Circular photo */}
                <div
                  className={`h-20 w-20 rounded-full overflow-hidden ring-1 ring-charcoal/10 shadow-[0_10px_30px_-15px_rgba(34,34,34,0.5)] ${
                    t.type === "logo" ? "bg-white p-2" : "bg-cream"
                  }`}
                >
                  <img
                    src={t.photo}
                    alt={t.name}
                    loading="lazy"
                    decoding="async"
                    className={`h-full w-full ${t.type === "logo" ? "object-contain" : "object-cover"}`}
                  />
                </div>

                {/* Stars */}
                <div className="mt-5 flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={15} className="fill-gold text-gold" />
                  ))}
                </div>

                {/* Quote */}
                <p className="mt-5 flex-1 font-heading text-lg leading-snug text-charcoal">
                  "{t.quote}"
                </p>

                {/* Author */}
                <div className="mt-7">
                  <p className="font-medium text-charcoal">{t.name}</p>
                  <p className="text-sm text-charcoal/50 mt-0.5">{t.role}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
